// Opens the 1:1 compose drawer; the drawer mounts only while open (fresh idempotency key each time).
import { Mail } from "lucide-react";
import { useTranslate } from "ra-core";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ComposeEmailDrawer } from "./ComposeEmailDrawer";

type Props = {
  companyId?: number | null;
  contactId?: number | null;
  dealId?: number | null;
  defaultTo: string[];
};

export const ComposeEmailButton = (p: Props) => {
  const t = useTranslate();
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setOpen(true)}>
        <Mail className="size-4" aria-hidden="true" />
        {t("gavion.compose.open")}
      </Button>
      {open && <ComposeEmailDrawer open={open} onOpenChange={setOpen} {...p} />}
    </>
  );
};
